import React, { memo } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import List from 'components/Common/List/List'

interface Props {
  roomType: App.PackageRoomType
}

function LePackageUpgradeCardRoomDetails({ roomType }: Props) {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={12}>
      <BodyText variant="small" weight="bold">{intl.formatMessage({
        id: 'evZ_7bsnwDkyD0kGieW-',
        defaultMessage: 'About The Room',
        description: 'Heading for room description section in package upgrade card',
      })}
      </BodyText>
      {roomType.description &&
        <BodyText variant="small">{roomType.description}</BodyText>}
      {!!roomType.amenities?.length && (
        <Group direction="vertical" gap={12}>
          <BodyText variant="small" weight="bold">{intl.formatMessage({
            id: 'nA94DrRuGnawPqbfFT_m',
            defaultMessage: 'Room Facilities',
            description: 'Heading for room facilities/amenities section in package upgrade card',
          })}
          </BodyText>
          <List>
            {roomType.amenities.map(amenity =>
              <BodyText key={amenity.id} as="li" variant="small">{amenity.description}</BodyText>,
            )}
          </List>
        </Group>
      )}
    </Group>
  )
}

export default memo(LePackageUpgradeCardRoomDetails)
